var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDecline = function SvgDecline(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 28 12.8",
    style: {
      enableBackground: "new 0 0 28 12.8"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Webphone_new_3",
    transform: "translate(-174.000000, -566.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(158.000000, 542.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    fill: "#fff",
    d: "M44,33.2c0-0.9-0.4-1.8-1.1-2.5l0,0l-2.6-2.5c-5.7-5.6-15-5.6-20.7,0l0,0l-2.6,2.5 c-0.7,0.7-1.1,1.6-1.1,2.5l0,0v0c0,0.2,0,0.5,0.1,0.7l0,0c0.1,0.7,0.5,1.3,1,1.8l0,0c1.4,1.4,3.7,1.4,5.2,0l0,0l2.6-2.5 c2.9-2.8,7.5-2.8,10.3,0l0,0l2.6,2.5c1.4,1.4,3.7,1.4,5.2,0l0,0c0.5-0.5,0.9-1.2,1-1.8l0,0C44,33.7,44,33.5,44,33.2L44,33.2 L44,33.2z"
  })))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDecline, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/decline.032a5e3c.svg";
export { ForwardRef as ReactComponent };